import React, { useEffect, useRef, useState } from 'react'
import { TComptuedKey } from '../../shared/types/exam.type'
import { Box, Typography } from '@mui/material';
import '../../eq-icons.css'
import { get, inRange, toNumber } from 'lodash';
import styled from '@emotion/styled';
import { useAuth } from '../../hooks/useAuth';
import { TUser } from '../../shared/types/user.type';
function ParamSection({ param, index, length, printable = false }: { param: TComptuedKey, index: number, length: number, printable?: boolean }) {


  const { auth } = useAuth()


  //Get the user type if polo or other type
  const userType = auth?.['type']

  const getText = () => {
    let value = get(param, 'formatted_value', "")
    let unit = get(param, 'key_parameter_layout.insight_parameter.unit_translated', "")

    if (!value) {
      return '-'
    }
    return value.concat(' ').concat(getUnits(unit, value))

  }

  const getUnits = (unit: string, value: string) => {

    if (["mm:ss.ms", "hh:mm:ss"].includes(unit)) {
      if (!value.includes(':')) {
        return " s"
      }
      return ""
    }
    if (unit === 's') {
      return toNumber(value) <= 60 ? ' s' : ''
    }
    return unit
  }



  return <Box sx={{ minHeight: '100%', breakInside: 'avoid' }} position={'relative'} >
    <BorderedDiv userType={userType} printable={printable} index={index} length={length}>
      <Box display={'flex'} p={1} justifyContent={'center'} alignItems={'center'} flexDirection={'column'} flex={1}>
        <div className="icon" >
          <span className={`eq-${param?.key_parameter_layout?.insight_parameter?.icon} eq-icon-2`}>
            <span className="path1"></span><span className="path2"></span><span className="path3"></span><span className="path4"></span><span className="path5"></span><span className="path6"></span><span className="path7"></span><span className="path8"></span></span>
        </div>
        <Typography textAlign={'center'} variant='body2' fontSize={{ md: 16, xs: 14 }}   >{getText()}</Typography>
        <Typography variant='body2' color={'#808080'} fontSize={{ md: 14, xs: 13 }} textAlign={'center'}>{get(param, 'key_parameter_layout.insight_parameter.name_translated', "")}</Typography>
      </Box>
    </BorderedDiv>
  </Box>
}


const BorderedDiv = styled.div<{ index: number, length: number, printable?: boolean, userType?: TUser['type'] }>`

&::after{
    content: '';
    position: absolute;
    top: 0;
    bottom:0;
    width: 0.5px;
    height: 85%;
    margin: auto;
    left: 0;
    background-color: ${props => (props.index % 4 === 1 ||
    props.index % 4 === 1 && props.userType === 'POLO' && props.index === 13)
    ? 'transparent'
    : '#808080'};
}

&::before{
  content: '';
  position: absolute;
  bottom: 0;
  width: 90%;
    left:0;
    right:0;
  margin: auto;
  height: 0.5px;
  background-color: ${props => {

    let itemsPerRow = 4

    let length = props.length

    let lentghMinisItemsPerRow = length - itemsPerRow

    let shouldHideBorder = inRange(props.index, lentghMinisItemsPerRow+1 , length + 1)


    return shouldHideBorder ? 'transparent' : '#808080'
  }};
}

  /* Media query styles for ::before and ::after */
  /* Conditionally render media query only if printable is false */
  ${props => !props.printable && `
    @media (max-width: 900px) {
      &::before {
        content: '';
        position: absolute;
        bottom: 0;
        width: 90%;
        margin-inline: auto;
        height: 0.5px;
    background-color: ${(() => {

      let itemsPerRow = 2

      let length = props.length

      let lentghMinisItemsPerRow = length - itemsPerRow

      let shouldHideBorder = inRange(props.index, lentghMinisItemsPerRow+1 , length + 1)


      return shouldHideBorder ? 'transparent' : '#808080'
    })()};
            }

      &::after {
        content: '';
        position: absolute;
        width: 0.5px;
        height: 90%;
       margin: auto;
        background-color: ${props.index % 2 === 1 || (props.userType === 'POLO' && props.index === 13)
      ? 'transparent'
      : '#808080'};
            }
    }
  `}

`

export default ParamSection